import React, { useEffect, useState } from "react";
import './ProgramacionDeServicio.scss'
import TitleView from "../../../components/atoms/TitleView/TitleView";
import { formateoBasico } from "../../../utilities/formateos";
import GlovalCard from "../../../components/atoms/GlovalCard/GlovalCard";
import camionIcon from '../../../assets/icons/bus.png'
import userIcon from '../../../assets/icons/user.png'
import calendarIcon from '../../../assets/icons/calendarioAdd.png'
import calendarCanceladoIcon from '../../../assets/icons/calendarioCancelado.png'
import proibidoIcon from '../../../assets/icons/proibido.png'
import reloadIcon from '../../../assets/icons/reload.png'
import InputLista from "../../../components/atoms/InputLista/InputLista";
import TextArea from "../../../components/atoms/TextArea/TextArea";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import Button from "../../../components/atoms/Button/Button";
import { getClients } from "../../monitoreo/MonitoreoServicios/MonitoreoServiciosIntegracion";
import { transferisServiciosIntegracion } from "../../monitoreo/TransferirServicios/transferisServiciosIntegracion";
import Swal from "sweetalert2";
import { ProgramacionDeServiciosIntegracion } from "./ProgramacionDeServiciosIntegracion";
import { jwtDecode } from "jwt-decode";
import ProgramacionDeServiciosTabla from './ProgramacionDeServiciosTabla'
const ProgramacionDeServicio = () => {
    const [clientes, setClientes] = useState([])
    const [cliente, setCliente] = useState("")
    const [rutas, setRutas] = useState([])
    const [ruta, setRuta] = useState("")
    const [estructuras, setEStructuras] = useState([])
    const [estructura, setEStructura] = useState(null)
    const [lunes, setLunes] = useState(0)
    const [martes, setMartes] = useState(0)
    const [miercoles, setMiercoles] = useState(0)
    const [jueves, setJueves] = useState(0)
    const [viernes, setViernes] = useState(0)
    const [sabado, setSabado] = useState(0)
    const [domingo, setDomingo] = useState(0)
    const [desde, setDesde] = useState(formateoBasico(new Date()))
    const [hasta, setHasta] = useState(formateoBasico(new Date()))
    const [proveedores, setProveedores] = useState([{ name: "SUMA TE LLEVA", code: 1 }])
    const [proveedor, setProveedor] = useState([])
    const [operadores, setOperadores] = useState([])
    const [operador, setOperador] = useState(null)
    const [programacionContadores, setProgramacionContadores] = useState(null)

    const [operadoresNoDisponibles, setOperadoresNoDisponibles] = useState([])
    const [unidadesNoDisponibles, setUnidadesNoDisponibles] = useState([])
        
    useEffect(() => {
        getClients(setClientes)
        transferisServiciosIntegracion.getProveedores(setProveedores)
        setProveedor({ name: "SUMA TE LLEVA", code: 1 })
        transferisServiciosIntegracion.getOperadores(setOperadores)
        ProgramacionDeServiciosIntegracion.getOperadoresNoDispobles(desde, setOperadoresNoDisponibles)
        ProgramacionDeServiciosIntegracion.getUnidadesNoDispobles(desde, setUnidadesNoDisponibles)
    }, [])
    useEffect(() => {
        if (cliente) {
            transferisServiciosIntegracion.getRutesByIdClient(cliente.code, setRutas)
        }

    }, [cliente])
    useEffect(() => {
        if (ruta) {

            transferisServiciosIntegracion.getEstructuraByRuta(ruta.code, setEStructuras)
        }

    }, [ruta])
    useEffect(() => {
        if (estructura) {
            setLunes(estructura.LUNES)
            setMartes(estructura.MARTES)
            setMiercoles(estructura.MIERCOLES)
            setJueves(estructura.JUEVES)
            setViernes(estructura.VIERNES)
            setSabado(estructura.SABADO)
            setDomingo(estructura.DOMINGO)
        }

    }, [estructura])



    const send = () => {
        const token = jwtDecode(sessionStorage.getItem("token"))
        const data = {
            // fecha_inicio:convertirFormatoFecha(desde)",
            // fecha_fin:convertirFormatoFecha(hasta),
            fecha_inicio:desde ,
            fecha_fin:hasta,
            cliente: cliente?.code,
            estructura: estructura?.code,
            lunes: lunes,
            martes: martes,
            miercoles: miercoles,
            jueves: jueves,
            viernes: viernes,
            sabado: sabado,
            domingo: domingo,
            proveedor: proveedor?.code,
            operador: operador?.code,
            ruta: ruta?.code,
            // motivo:motivo,
            id_usuario: token.ID
        }

        if (cliente?.code && estructura?.code && proveedor?.code && ruta?.code) {
            if(proveedor?.code != 1)
            {
                ProgramacionDeServiciosIntegracion.programar(data, setProgramacionContadores)
            }
            else{
                if(operador?.code)
                {
                    ProgramacionDeServiciosIntegracion.programar(data, setProgramacionContadores)
                }
                else{
                    Swal.fire({
                        icon: 'error',   // Icono de error
                        text: 'Rellena todos los campos obligatorios', // Mensaje de error
                        confirmButtonText: 'OK'  // Texto del botón de confirmación
                    });
                }
            }
        }
        else {
            Swal.fire({
                icon: 'error',   // Icono de error
                text: 'Rellena todos los campos obligatorios', // Mensaje de error
                confirmButtonText: 'OK'  // Texto del botón de confirmación
            });
        }


    }


    return (
        <div className="ProgramacionDeServicio">
            <TitleView title={"Programación servicios"}></TitleView>
            <div className="parent-ProgramacionDeServicio">
                <div className="col1">
                    <GlovalCard>
                        <b>
                            <div className="contenedorPrincipal">
                                <div className="contenedorInputs">
                                    <InputCalendario value={desde} onChange={(e) => { setDesde(e.target.value) }} titulo={"Desde"}></InputCalendario>
                                    <InputCalendario value={hasta} onChange={(e) => { setHasta(e.target.value) }} titulo={"Hasta"}></InputCalendario>
                                    <InputLista options={clientes} value={cliente} onChange={(e) => { setCliente(e.value) }} titulo={"Cliente"}></InputLista>
                                </div>
                                <div className="contenedorInputs">
                                    <InputLista options={rutas} value={ruta} onChange={(e) => { setRuta(e.value) }} titulo={"Ruta"}></InputLista>
                                    <InputLista options={estructuras} value={estructura} onChange={(e) => { setEStructura(e.value) }} titulo={"Estructura"}></InputLista>
                                </div>
                                <div className="contenedorInputs">
                                    <div className="dias">
                                        <div className="radio"><div>L</div><input disabled={!estructura?.LUNES} onChange={(e) => { setLunes(e.target.checked) }} type="checkbox" name="option" checked={lunes} /></div>
                                        <div className="radio"><div>M</div><input disabled={!estructura?.MARTES} onChange={(e) => { setMartes(e.target.checked) }} type="checkbox" name="option" checked={martes} /></div>
                                        <div className="radio"><div>M</div><input disabled={!estructura?.MIERCOLES} onChange={(e) => { setMiercoles(e.target.checked) }} type="checkbox" name="option" checked={miercoles} /></div>
                                        <div className="radio"><div>J</div><input disabled={!estructura?.JUEVES} onChange={(e) => { setJueves(e.target.checked) }} type="checkbox" name="option" checked={jueves} /></div>
                                        <div className="radio"><div>V</div><input disabled={!estructura?.VIERNES} onChange={(e) => { setViernes(e.target.checked) }} type="checkbox" name="option" checked={viernes} /></div>
                                        <div className="radio"><div>S</div><input disabled={!estructura?.SABADO} onChange={(e) => { setSabado(e.target.checked) }} type="checkbox" name="option" checked={sabado} /></div>
                                        <div className="radio"><div>D</div><input disabled={!estructura?.DOMINGO} onChange={(e) => { setDomingo(e.target.checked) }} type="checkbox" name="option" checked={domingo} /></div>
                                    </div>
                                </div>
                                <div className="contenedorInputs">
                                    <InputLista options={proveedores} placeholder={proveedor?.name} value={proveedor} onChange={(e) => { setProveedor(e.value) }} titulo={"Proveedor"}></InputLista>
                                    <InputLista options={operadores} placeholder={operador?.name} value={operador} onChange={(e) => { setOperador(e.value) }} titulo={"Operador"}></InputLista>
                                </div>
                            </div>
                        </b>
                        <div className="buttonContainer">
                            <Button className={"buttonProgramar"} onClick={() => { send() }} >Programar</Button>
                        </div>
                        {/* ------------------------------- resultados */}
                        <div className="resultados">
                            <div className="contador">
                                <div className="contadorEIncono">
                                    <div className="flex">
                                        <img src={calendarIcon} alt="" />
                                        <div className="numero">{programacionContadores?.contador_bitacoras_programadas ? programacionContadores.contador_bitacoras_programadas : 0}</div>
                                    </div>
                                    <div className="descripcion">Servicios programados</div>
                                </div>
                            </div>
                            <div className="contador">
                                <div className="contadorEIncono">
                                    <div className="flex">
                                        <img src={reloadIcon} alt="" />
                                        <div className="numero">{programacionContadores?.contador_bitacoras_activados ? programacionContadores?.contador_bitacoras_activados : 0}</div>
                                    </div>
                                    <div className="descripcion">Servicios reactivados</div>
                                </div>
                            </div>
                            <div className="contador">
                                <div className="contadorEIncono">
                                    <div className="flex">
                                        <img src={calendarCanceladoIcon} alt="" />
                                        <div className="numero">{programacionContadores?.contador_bitacoras_cancelados ? programacionContadores?.contador_bitacoras_cancelados : 0}</div>
                                    </div>
                                    <div className="descripcion">Servicios cancelados</div>
                                </div>
                            </div>
                            <div className="contador">
                                <div className="contadorEIncono">
                                    <div className="flex">
                                        <img src={proibidoIcon} alt="" />
                                        <div className="numero">{programacionContadores?.contador_bitacoras_no_modificados ? programacionContadores?.contador_bitacoras_no_modificados : 0}</div>
                                    </div>
                                    <div className="descripcion">Servicios no modificados</div>
                                </div>
                            </div>
                        </div>
                    </GlovalCard>
                    <GlovalCard>
                        <div className="programacionOperador">
                            {
                                programacionContadores ?
                                    <>
                                        <div className="title">
                                            Programación actual General
                                        </div>
                                        <div className="bitacoras">
                                            <ProgramacionDeServiciosTabla data={programacionContadores?.bitacoras}></ProgramacionDeServiciosTabla>
                                        </div>
                                    </> : ""
                            }
                        </div>
                    </GlovalCard>
                </div>
                <div className="col2">
                    <GlovalCard>
                        <div className="title">Datos actualizados {formateoBasico(new Date())}</div>
                        <div className="operadores-container">
                            <div className="subtitle">Operadores no disponibles</div>
                            {
                                operadoresNoDisponibles.map((item, key) => {
                                    return (
                                        <div className="unidadNoDisponible">
                                            <img width={16} src={userIcon} alt="" />
                                            <div className="tipo"> | {item.NOMBRE} → </div>
                                            <div className="motivo">{item.ESTATUS} </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="operadores-container">
                            <div className="subtitle">Unidades no disponibles</div>
                            {
                                unidadesNoDisponibles.map((item, key) => {
                                    return (
                                        <div className="unidadNoDisponible">
                                            <img width={16} src={camionIcon} alt="" />
                                            <div className="unidad">U - {item.ID}</div>
                                            <div className="tipo"> | {item.DESCRIPCION} → </div>
                                            <div className="motivo">{item.U_DISPONIBLE} </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </GlovalCard>

                </div>
            </div>
        </div>
    )
}
export default ProgramacionDeServicio